import React from 'react';

import { cn } from '@blockworks/ui/utils';

type ILogoProps = {
    className?: string;
    style?: 'black' | 'white';
};

const Logo = (props: ILogoProps) => {
    return (
        <svg
            className={cn(
                'flex-grow-0 flex-shrink-0 h-6 relative',
                props.style === 'white' ? 'text-[#F9FAFB]' : 'text-black',
                props.className,
            )}
            width="153"
            height="25"
            viewBox="0 0 153 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
        >
            <path d="M21.8687 0.850525H17.4619V24.3364H21.8687V0.850525Z" fill="currentColor" />
            <path
                d="M31.2406 7.54004C26.371 7.54004 22.6997 11.1542 22.6997 16.1824C22.7185 17.869 23.2358 19.5123 24.1866 20.9054C25.1374 22.2986 26.4792 23.3793 28.0429 24.0114C29.6066 24.6436 31.3224 24.799 32.9743 24.458C34.6261 24.1171 36.1402 23.295 37.3258 22.0953C38.5114 20.8956 39.3155 19.3719 39.637 17.7162C39.9584 16.0604 39.7828 14.3466 39.1322 12.7904C38.4816 11.2343 37.3852 9.90537 35.9809 8.97109C34.5766 8.0368 32.9273 7.53889 31.2406 7.54004V7.54004ZM31.2406 20.8237C29.0911 20.8237 27.1001 19.2323 27.1001 16.1824C27.1001 13.1325 29.0911 11.56 31.2406 11.56C33.3901 11.56 35.3811 13.1198 35.3811 16.1951C35.3811 19.2703 33.3964 20.8237 31.2406 20.8237Z"
                fill="currentColor"
            />
            <path
                d="M48.7409 20.7857C46.49 20.7857 44.5687 19.1308 44.5687 16.1824C44.5687 13.234 46.4709 11.6171 48.7092 11.6171C49.5363 11.5824 50.3496 11.8378 51.0084 12.3391C51.6671 12.8404 52.13 13.5562 52.3171 14.3626L56.261 13.0374C55.5635 10.2919 53.0462 7.54004 48.6078 7.54004C43.8713 7.54004 40.162 11.1542 40.162 16.1824C40.1327 17.3202 40.3341 18.4522 40.7539 19.5102C41.1738 20.5681 41.8035 21.5301 42.6051 22.3382C43.4067 23.1463 44.3635 23.7837 45.418 24.2122C46.4725 24.6406 47.6029 24.8511 48.7409 24.8311C53.0779 24.8311 55.6269 22.0475 56.3497 19.3337L52.4756 18.0656C52.2495 18.8728 51.758 19.5803 51.0804 20.0739C50.4028 20.5674 49.5786 20.8182 48.7409 20.7857V20.7857Z"
                fill="currentColor"
            />
            <path
                d="M92.536 8.04085L89.5242 18.541L86.0115 8.04085H81.3764L77.832 18.503L74.8138 8.04085H72.7531H70.1788H66.9894L61.3589 14.1025V0.850525H56.9521V24.3364H61.3589V20.0311L63.1787 18.1099L67.484 24.3364H72.8799L66.2222 14.8951L70.8256 10.0635L75.3782 24.3364H79.8483L83.5957 13.2085L87.4001 24.3364H91.8069L96.9048 8.04085H92.536Z"
                fill="currentColor"
            />
            <path
                d="M104.52 7.53998C102.804 7.5186 101.122 8.00777 99.685 8.94529C98.2485 9.88281 97.1232 11.2263 96.4523 12.805C95.7813 14.3837 95.5949 16.1263 95.9169 17.8112C96.2388 19.4961 97.0546 21.0472 98.2603 22.2673C99.4661 23.4874 101.007 24.3214 102.688 24.6632C104.369 25.005 106.114 24.8393 107.701 24.187C109.287 23.5347 110.644 22.4254 111.598 21C112.553 19.5747 113.062 17.8977 113.061 16.1823C113.061 11.1542 109.389 7.53998 104.52 7.53998ZM104.52 20.8237C102.364 20.8237 100.379 19.2322 100.379 16.1823C100.379 13.1325 102.364 11.5473 104.52 11.5473C106.675 11.5473 108.66 13.1071 108.66 16.1823C108.66 19.2576 106.669 20.8237 104.52 20.8237Z"
                fill="currentColor"
            />
            <path
                d="M118.165 10.4567V8.04088H113.891V24.3301H118.33V16.8798C118.33 13.3671 120.283 12.2765 122.533 12.2765C122.979 12.2754 123.423 12.32 123.859 12.4096V7.97113C123.529 7.97113 123.193 7.90771 122.831 7.90771C121.405 7.90771 119.154 8.30085 118.165 10.4567Z"
                fill="currentColor"
            />
            <path
                d="M140.325 8.04085H134.562L128.931 14.1025V0.850525H124.524V24.3364H128.931V20.0311L130.751 18.1099L135.056 24.3364H140.452L133.801 14.8951L140.325 8.04085Z"
                fill="currentColor"
            />
            <path
                d="M147.541 14.464L145.227 13.9631C144.333 13.7983 143.737 13.3291 143.737 12.5111C143.737 11.579 144.663 10.8879 145.823 10.8879C146.466 10.8323 147.105 11.0288 147.605 11.4359C148.106 11.8429 148.428 12.4286 148.505 13.0691L152.183 12.2448C151.98 10.4884 150.426 7.54004 145.791 7.54004C142.278 7.54004 139.698 9.95584 139.698 12.8726C139.698 15.1615 141.118 17.0447 144.263 17.7422L146.419 18.2368C147.687 18.5031 148.175 19.0991 148.175 19.8283C148.175 20.6906 147.478 21.4515 146.019 21.4515C144.117 21.4515 143.141 20.2594 143.039 18.9659L139.267 19.8029C139.463 21.6544 141.169 24.8374 146.051 24.8374C150.325 24.8374 152.392 22.1173 152.392 19.4732C152.379 17.0764 150.756 15.1235 147.541 14.464Z"
                fill="currentColor"
            />
            <path opacity="0.3" d="M5.87147 12.5808H0V18.4523H5.87147V12.5808Z" fill="currentColor" />
            <path opacity="0.2" d="M5.87147 18.4459H0V24.3174H5.87147V18.4459Z" fill="currentColor" />
            <path opacity="0.8" d="M5.87147 0.837891H0V6.70936H5.87147V0.837891Z" fill="currentColor" />
            <path opacity="0.5" d="M5.87147 6.70935H0V12.5808H5.87147V6.70935Z" fill="currentColor" />
            <path
                opacity="0.9"
                d="M10.8426 0.87596C10.656 0.847323 10.4672 0.834597 10.2783 0.837918H5.83984V6.70305H11.705V1.11057C11.424 1.01022 11.1357 0.931776 10.8426 0.87596V0.87596Z"
                fill="currentColor"
            />
            <path
                d="M15.6993 6.70298C15.6976 5.47865 15.3153 4.28514 14.6052 3.2877C13.8952 2.29027 12.8926 1.53828 11.7363 1.13586V6.72835L15.6993 6.70298Z"
                fill="currentColor"
            />
            <path
                opacity="0.9"
                d="M15.6993 6.703H11.7363V12.2447C12.8886 11.8438 13.8883 11.0956 14.5979 10.1033C15.3076 9.11088 15.6923 7.923 15.6993 6.703Z"
                fill="currentColor"
            />
            <path
                opacity="0.8"
                d="M5.87158 6.703V12.5745H9.80281C10.4502 12.5902 11.0949 12.487 11.705 12.2701V6.72837L5.87158 6.703Z"
                fill="currentColor"
            />
            <path
                opacity="0.5"
                d="M10.9948 12.5745C10.8173 12.5745 10.6334 12.5745 10.4559 12.5745H5.85889V18.4459H11.724V12.6949C11.4838 12.6389 11.2403 12.5987 10.9948 12.5745Z"
                fill="currentColor"
            />
            <path
                opacity="0.8"
                d="M11.7363 12.6949V18.4459H16.3523C16.3523 17.1051 15.8949 15.8044 15.0556 14.7587C14.2163 13.7131 13.0454 12.9851 11.7363 12.6949V12.6949Z"
                fill="currentColor"
            />
            <path
                opacity="0.3"
                d="M5.87158 18.4459V24.3174H10.9949C11.2445 24.2937 11.4924 24.2535 11.7367 24.1969V18.4459H5.87158Z"
                fill="currentColor"
            />
            <path
                opacity="0.5"
                d="M11.7363 24.1969C13.0454 23.9068 14.2163 23.1788 15.0556 22.1331C15.8949 21.0875 16.3523 19.7868 16.3523 18.4459H11.7363V24.1969Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Logo;
